<template>
    <div id="app" v-if="content.loaded">
        <component :is="loadHeader" :header-data="content.header"></component>
        <Content :page-data="content.pages" v-model:profile-caller-id="profileCallerId" v-model:uses-threat-metrics-only="usesThreatMetricsOnly"></Content>
        <component :is="loadFooter" :footer-data="content.footer"></component>
    </div>
</template>

<script>
    import Content from './components/base/global/Content.vue'
    import {ThreatMetricsHandler} from './components/base/mixins/ThreatMetricsHandler.js';
    //import {goToIndexPage} from '../src/utility/miscellaneous';
    import { defineAsyncComponent } from 'vue';
    import merge from "lodash/merge";

    export default {
        name: 'LoginApp',

        components: {
            Content
        },

        mixins: [
            ThreatMetricsHandler
        ],

        methods: {
            //goToIndexPage,
            isOverridden: function(file) {
                return this.content.fileOverrides[file];
            },

            getClient: function() {
                return this.content.clientPath;
            },

            getClientTitle: function(){
                return this.content.clientTitle;
            },

            getSourcePath: function() {
                return this.srcPath;
            },

            isBaseClient: function() {
                return this.getClient() === "base";
            },

            getClientProfile: function() {
                return this.clientProfile;
            },

            getContactUsMessage: function() {
                return this.content.contactUs;
            },

            getGenericErrorMessage: function() {
                return this.content.genericErrorMessage;
            },

            getPasswordRequirements: function() {
                return this.content.passwordRequirements;
            },

            getUsernameRequirements: function() {
                return this.content.usernameRequirements;
            },

            resetTimeout: function() {
                if (this.timeoutInterval !== 0) {
                    if (this.timeout !== null) {
                        clearTimeout(this.timeout);
                    }
                    this.timeout = setTimeout(function() {
                        window.location.href = window.location.href;
                    }, this.timeoutInterval);
                }
            },

            setupInterceptors: function() {
                this.$axios.interceptors.request.use(function(request) {
                    this.$emitter.emit('reset-timeout');
                    return request;
                }.bind(this), function(error) {
                    this.$emitter.emit('reset-timeout');
                    return Promise.reject(error);
                }.bind(this));

                this.$axios.interceptors.response.use(function(response) {
                    this.$emitter.emit('reset-timeout');
                    return response;
                }.bind(this), function(error) {
                    this.$emitter.emit('reset-timeout');
                    return Promise.reject(error);
                }.bind(this));
            },
            initiateThreatMetricsProfiling: function() {
                this.beginThreatMetrics(this.clientProfile);
            }
        },

        data: function() {
            return {
                content: {},
                clientProfile: {},
                timeoutInterval: 0,
                timeout: null
            }
        },

        created: function() {
            this.$emitter.on('reset-timeout', this.resetTimeout);
            this.$emitter.on('reprofileThreatMatrics', this.initiateThreatMetricsProfiling);
            var time = new Date().getTime();
            var client = window.location.pathname.replace('/BFWeb','').split('/')[2];
            this.$axios.get('/clients/' + client + '/content.json?t=' + time).then(function(response) {
                this.content = response.data;
                document.title = this.content.title;
                if (!this.isBaseClient()) {
                    this.$axios.get('/clients/base/content.json?t=' + time).then(function(response) {
                        merge(response.data, this.content);
                        this.content = response.data;
                        this.content.loaded = true;
                        this.cssVars({variables: this.content.styles});
                    }.bind(this));
                }
                else {
                    this.content.loaded = true;
                    this.cssVars({variables: this.content.styles});
                }
            }.bind(this));
        },

        mounted: function() {    
            //this.goToIndexPage();
            delete this.$root.username; 
            delete this.$root.age;
            delete this.$root.maId;
            delete this.$root.isPortfolioDataLoad;
            delete this.$root.hasTaData;
            sessionStorage.clear();    
            this.$axios.get('clientProfile?t=' + new Date().getTime()).then(function(response) {
                this.clientProfile = response.data.data;
                // Convert to seconds and subract 1 second to ensure no session error occurs
                this.timeoutInterval = parseInt(this.clientProfile.timeout) * 60 * 1000 - 1000;
                this.setupInterceptors();
                this.initiateThreatMetricsProfiling();
            }.bind(this));
        },

        unmounted: function() {
            this.$emitter.off('reset-timeout', this.resetTimeout);
            this.$emitter.off('reprofileThreatMatrics', this.initiateThreatMetricsProfiling);
        },

        computed: {
            loadHeader: function() {                
                var client = "base";
                if (this.content.fileOverrides.header) {
                    client = this.getSourcePath();
                }

                return defineAsyncComponent(function() { return import('./components/' + client + '/global/Header.vue');});
            },

            loadFooter: function() {
                var client = "base";
                if (this.content.fileOverrides.footer) {
                    client = this.getSourcePath();
                }

                return defineAsyncComponent(function() { return import('./components/' + client + '/global/Footer.vue');});
            },

            srcPath: function() {
                var client = this.getClient();
                return client.indexOf('-stage') ? client.replace('-stage','') : client;
            }
        },

        watch: {
            timeoutInterval: function(val) {
                this.$emitter.emit('reset-timeout');
            }
        },

        provide: function() {
            return {
                getClient: this.getClient,
                getClientTitle: this.getClientTitle,
                getSourcePath: this.getSourcePath,
                getClientProfile: this.getClientProfile,
                getContactUsMessage: this.getContactUsMessage,
                getGenericErrorMessage: this.getGenericErrorMessage,
                getPasswordRequirements: this.getPasswordRequirements,
                getUsernameRequirements: this.getUsernameRequirements
            }
        }
    }
</script>

<style>
    html, body {
        height: 100%;
        width: 100%;
        padding: 0px;
        margin: 0px;
    }

    body {
        height: auto;
    }

    #app {
        background: var(--app-bg-color);
        margin: auto;
        font-family: var(--font-family);
        color: var(--font-color);
        height: 100vh;
        display: flex;
        flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
    }

    .content {
        max-width: 1440px;
        margin: 0 auto;
        box-sizing: border-box;
        flex: 1 0 auto;
        -webkit-box-flex: 1;
    }

    footer, header {
        flex-shrink: 0;
    }

    h2 {
        font-size: 20px;
    }

    .hidden {
        display: none !important;
    }

    .help-icon {
        position: absolute;
        top: 1rem;
        right: 1rem;
        font-size: 1.25rem;
    }

    .icon {
        line-height: 1;
        cursor: pointer;
    }

    label, p, .fine-print {
        font-size: 14px;
    }

    .extra-fine-print {
        font-size: 12px;
    }

    .btn-primary-primary, .btn-outline-primary {
        border: 2px solid var(--btn-border-color);
        box-sizing: border-box;
    }

    .btn-primary-primary, .btn-primary-primary.disabled:hover, .btn-primary-primary.disabled:active {
        background: var(--solid-btn-bg-color);
        color: var(--solid-btn-font-color);
    }

    .btn-primary-primary .spinner-border, .btn-primary-primary.disabled:hover .spinner-border, .btn-primary-primary.disabled:active .spinner-border {
        display: inline-flex;
        color: var(--solid-btn-font-color);
        width: 1.5rem;
        height: 1.5rem;
    }

    .btn-primary-primary svg.icon{
        color: var(--solid-btn-font-color);
    }

    .btn.disabled{
        opacity: 0.2;
    }

    .btn.disabled:focus {
        box-shadow: none;
    }

    .btn.disabled:hover, .btn.disabled:focus, .btn.disabled:active {
        cursor: default;
    }

    .btn-outline-primary {
        background: var(--outline-btn-bg-color);
        color: var(--outline-btn-font-color);
    }

    .btn-primary-primary:not(.disabled):hover {
        text-decoration: none !important;
        background-color: var(--btn-primary-hover-color) !important;
        color: #fff;
        border: 2px solid var(--btn-primary-hover-color);
    }

    .btn-primary-primary:not(.disabled):active, .btn-primary-primary:not(.disabled):focus{
        outline: 3px solid gray;
        background-color: var(--btn-primary-hover-color);
        text-decoration: underline !important;
    }
    .btn-outline-primary{
        border: 2px solid var(--btn-border-color);
    }
    .btn-outline-primary:not(.disabled):hover{
        color: var(--btn-primary-hover-color);
        text-decoration: none !important;
        background-color: var(--btn-outline-active-color);
        border: 2px solid var(--btn-primary-hover-color);
    }

    .btn-outline-primary:not(.disabled):active, .btn-outline-primary:not(.disabled):focus{
        text-decoration: underline !important;
        background-color: var(--btn-outline-active-color);
        border: 2px solid var(--btn-outline-active-color);
        border-radius: 6px;
        font-weight: normal;
        outline: 3px solid gray;
        outline-offset: -2px;
        box-shadow: none;
    }

   a,  .dropdown-menu a {
        color: var(--link-color);
    }

    a:not(.disabled):hover {
        color: var(--link-hover-color) !important;
        text-decoration: none;
    }

    .dropdown-menu a:hover{
        color: #fff !important;
    }

    .theme-primary {
        color: var(--primary-bg-color);
    }

    .theme-primary:checked~.custom-control-label:before {
        background: var(--primary-bg-color);
        border-color: var(--primary-bg-color);
        cursor: pointer;
    }

    .theme-primary[type="checkbox"]:focus~.custom-control-label:before {
        box-shadow: var(--input-focus-shadow);
    }  

    .card {
        padding: 2.5rem;
        margin: 2rem 0rem;
        box-shadow: 3px 3px 4px #dee2e6;
    }

    .card-body {
        padding: 1.25rem;
    }

    .custom-control p {
        margin-top: 10px;
    }

    @media(max-width: 767px) {
        .login-container {
            padding: 0px;
        }

        .login-container .card {
            box-shadow: none;
            border: none;
            margin: 0px;
            padding: 0px;
        }

        .login-container .card .card-body {
            padding: 1.5rem 1.5rem 3.5rem;
        }
        
        .help-icon {
            position: relative;
            display: block;
            margin-bottom: 2rem;
        }
    }

    input[type="text"]:focus,
    input[type="password"]:focus,
    input[type="number"]:focus,
    input[type="date"]:focus,
    input[type="email"]:focus,
    input[type="tel"]:focus {
        box-shadow: var(--input-focus-shadow);
        border-color: var(--input-focus-border-color);
    }
    
    select:active, select:focus {
        box-shadow: var(--input-focus-shadow) !important;
        border-color: var(--input-focus-border-color) !important;
    }

    input[type="text"].error,
    input[type="password"].error,
    input[type="number"].error,
    input[type="date"].error,
    input[type="email"].error,
    input[type="tel"].error,
    select.error {
        border: 2px solid var(--input-error-border-color) !important;
    }

    input[type="text"].error:focus,
    input[type="password"].error:focus,
    input[type="number"].error:focus,
    input[type="date"].error:focus,
    input[type="email"].error:focus,
    input[type="tel"].error:focus,
    select.error {
       box-shadow: var(--input-error-shadow);
}

    .icon-label {
        padding-top: .125rem;
    }

    .spinner-border {
        margin: auto;
        display: flex;
        color: var(--spinner-border-color);
    }

    .icon-button {
        width: 50px;
        justify-content: center;
        transition: all 150ms ease;
        margin-bottom: 1px;
        border: 1px solid var(--button-icon-border);
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
        transition: all 150ms ease;
        border-radius: 3px !important;
        z-index: 9;
    }

    .icon-button:hover, .icon-button:focus{
        background-color: var(--icon-button-hover-bg-color);
        outline: 0;
    }

    .card .help-icon {
        display: none;
    }

    .input-group-append {
        cursor: pointer;
    }
</style>